import React, { useRef, useState } from 'react';
import { LayoutPage } from '../../../components/Layout/layoutPage';
import TopBar from '../../../components/TopBar/TopBar';
import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useNavigate } from 'react-router-dom';
import { useStoreDispatch, useStoreSelector } from '../../../hooks/StoreHooks';
import { getCurrentUser } from '../../core/common_functions';
import { importBaseActions } from '../../../store/reducers/base';
import { useDispatch } from 'react-redux';
import { MeApi } from '../../api/me_api';

export const UserProfilePage = () => {
    const navigate = useNavigate();
    const base = useStoreSelector(state => state.base);
    const {setUser} = importBaseActions();
    const dispatcher = useStoreDispatch();
    const currentUser = getCurrentUser(base);    
    const [logo, setLogo] = useState<string | null>(currentUser?.logo ?? null);

    const setCustomerLogo = async (files: FileList|null) => {
        try {
            if (!files || files.length <= 0)  return;

            const [file] = files;
            if (file) {
                let img = await MeApi.setLogo(currentUser, file);
                dispatcher(setUser({...currentUser, logo: img.data}));
                setLogo(img.data ?? null);
            }
        } catch (e: any) {

        }
    }

    const removeCustomerLogo = async () => {
        try {
            await MeApi.removeLogo(currentUser);
            dispatcher(setUser({...currentUser, logo: null}));
            setLogo(null);
        } catch (e: any) {
            
        }
    }

    return (
        <LayoutPage>
            <div style={{ flex: "0 0 auto" }}>
                <TopBar />

                <div className={"d-flex justify-content-between p-3"}>
                    <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
                        <h2 className="h2 fw-bold">
                            Profilo cliente
                        </h2>
                    </div>
                    <div>
                        <Button variant="contained" color="secondary" onClick={() => navigate("/configurations")}>
                            <CloseIcon />
                            <span className="ms-2">CHIUDI</span>
                        </Button>
                    </div>
                </div>
            </div>

            <div style={{ flex: "1 1 auto", minHeight: "0" }}>
                <div className="container h-full" style={{ overflowY: "auto", height: "100%" }}>
                    <div className="row m-0">
                        <div className="col-12 p-0">
                            <div className="p-4">
                                <div className="row">
                                    <div className="col-xl-6">
                                        <h5 className="text-primary">Logo</h5>

                                        {!logo && (
                                            <div 
                                                className="d-flex flex-column justify-content-center align-items-center" 
                                                style={{
                                                    height: "200px", 
                                                    backgroundColor: "#f2f2f2", 
                                                    position: "relative",
                                                    border: "1px dashed #ccc",
                                                }}>
                                                <Button variant="contained" component="label" style={{position: "relative"}}>
                                                    <SearchIcon />
                                                    <span>Carica qui il tuo logo</span>
                                                    <input 
                                                        type="file"
                                                        style={{position: "absolute", top: "0", left: "0", width: "100%", height: "100%", opacity: "0", cursor: "pointer"}} 
                                                        onChange={(e) => setCustomerLogo(e.target.files)}
                                                    />
                                                </Button>
                                            </div>
                                        )}

                                        {logo && <div className="d-flex flex-column justify-content-center align-items-center" style={{
                                            height: "200px", 
                                            backgroundColor: "#f2f2f2", 
                                            position: "relative",
                                            border: "1px dashed #ccc",
                                        }}>
                                            <img src={logo} style={{height: "100%", width: "auto"}} />

                                            <Button 
                                                variant="contained" 
                                                color="primary" 
                                                onClick={() => removeCustomerLogo()} 
                                                style={{position: "absolute", bottom: "0", right: "0", borderRadius: "0"}}>
                                                <DeleteForeverIcon />
                                            </Button>
                                        </div>}
                                    </div>

                                    <div className="col-xl-6">
                                        <h5 className="text-primary">I miei dati</h5>

                                        <div className="mb-3">
                                            <label className="form-label">Codice</label>
                                            <input type="text" className="form-control" value={currentUser?.code} disabled />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Nome</label>
                                            <input type="text" className="form-control" value={currentUser?.firstName} disabled />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Cognome</label>
                                            <input type="text" className="form-control" value={currentUser?.lastName} disabled />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Azienda</label>
                                            <input type="text" className="form-control" value={currentUser?.businessName ?? ""} disabled />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Email</label>
                                            <input type="text" className="form-control" value={currentUser?.email ?? ""} disabled />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Telefono</label>
                                            <input type="text" className="form-control" value={currentUser?.phone ?? ""} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutPage>
    );
}